import { auth_request } from "./request";
import { baseUrl, request } from "./type";
import { withPackageOnlineStatus } from "@utils/packageOnlineStatus";
const router = "adminUsers";

// 儲值金建立
const createBalance = (token, branchId, data) => {
  return request("post", `${router}/balance/${branchId}`, token, data);
};

// 新增套票
const createPackage = (token, data) => {
  return request("post", `${router}/createPackage`, token, withPackageOnlineStatus(data));
};

// 取得套票
const getPackage = (token, branchId, options = {}) => {
  return request("get", `${router}/getPackage/${branchId}`, token, null, options);
};

// 購買套票
const buyPackage = (token, branchId, data) => {
  return auth_request(
    "post",
    baseUrl,
    `${router}/buyPackage/${branchId}`,
    token,
    data
  );
};

// 取得全部套票
const getMemberCheckoutPackage = (token, branchId) => {
  return request(
    "get",
    `${router}/getMemberCheckoutPackage/${branchId}`,
    token
  );
};

// 取得單人套票
const getMemberTicketByMemberId = (token, brandMemberId) => {
  return request(
    "get",
    `${router}/getMemberTicketByMemberId/${brandMemberId}`,
    token
  );
};

// 取得套票上下架狀態
const editPackageStatus = (token, brandMemberId, data) => {
  return request(
    "put",
    `${router}/editPackageStatus/${brandMemberId}`,
    token,
    data
  );
};

// 刪除套票
const delBrandProductsById = (token, brandProductsId) => {
  return request(
    "delete",
    `${router}/delBrandProductsById/${brandProductsId}`,
    token
  );
};

// 修改套票
const editPackage = (token, brandProductsId, data) => {
  return request(
    "put",
    `${router}/editPackage/${brandProductsId}`,
    token,
    withPackageOnlineStatus(data)
  );
};

//耗材紀錄
const consumablesRecord = (token, data, branchId) => {
  return auth_request(
    "get",
    baseUrl,
    `inventory/appointment-verifications?branchId=${branchId}`,
    token,
    data
  );
};

//耗材項目
const consumableItem = (token, branchId, id) => {
  return auth_request(
    "get",
    baseUrl,
    `inventory/appointment-verifications/${id}`,
    token,
    branchId
  );
};

//耗材項目
const updateAppointmentVerifications = (token, data) => {
  return auth_request(
    "patch",
    baseUrl,
    `inventory/appointment-verifications/bulk`,
    token,
    data
  );
};

// 增減點數
const adjustBrandMemberPoints = (token, data) => {
  return request("post", `${router}/adjustBrandMemberPoints`, token, data);
};
// 增減點數
const adjustUserPoints = (token, data) => {
  return request("post", `${router}/adjust-user-points`, token, data);
};

// 增減儲值金
const adjustBrandMemberBalance = (token, data) => {
  return request("post", `${router}/adjustBrandMemberBalance`, token, data);
};

// 點數歷史紀錄
const getBrandMemberPoints = (token, brandMemberId) => {
  return request(
    "get",
    `${router}/getBrandMemberPoints/${brandMemberId}`,
    token
  );
};

// 點數歷史紀錄
const getBrandMemberBalance = (token, brandMemberId) => {
  return request(
    "get",
    `${router}/getBrandMemberBalance/${brandMemberId}`,
    token
  );
};

// 發送優惠券
const sendCoupon = (token, data) => {
  return request("post", `${router}/sendCoupon`, token, data);
};

// getSendCoupon
const getSendCoupon = (token, brandId) => {
  return request("get", `${router}/getSendCoupon/brand/${brandId}`, token);
};

// ------------------Eternal----------------------

// CHARLENE
// 修改轉診
const updateReferralBranch = (token, data) => {
  return request("put", `${router}/updateReferral`, token, data);
};

// CHARLENE
// 新增會員驗證是否存在該手機號碼的介紹人（舊流程，保留相容）
const checkAnyIntroducerPhone = (token, data) => {
  return request("post", `${router}/checkAnyIntroducerPhone`, token, data);
};

// 以分店病歷號驗證介紹人（新流程）
const checkAnyIntroducerOrigin = (token, data) => {
  return request("post", `${router}/checkAnyIntroducerOrigin`, token, data);
};

// CHARLENE
// brandMemberBalanceLog
const brandMemberBalanceLog = (token, brandMemberId) => {
  return request(
    "get",
    `${router}/brandMemberBalanceLog?brandMemberId=${brandMemberId}`,
    token
  );
};

// CHARLENE
// brandTicketLog
// const brandTicketLog = (token, brandMemberId) => {
//   return request(
//     "get",
//     `${router}/brandTicketLog?brandMemberId=${brandMemberId}`,
//     token
//   );
// };

// CHARLENE
// switchBranch
const switchBranch = (token, switchBranchId) => {
  return request("post", `${router}/switchBranch`, token, switchBranchId);
};

// 取得轉診紀錄
const getReferralRecords = (token, userId) => {
  return request("get", `${router}/referralRecords/${userId}`, token);
};


// 取得今日備注
const getTodayNote = (token, branchId, type, eventDate) => {
  return request("get", `${router}/notes?branchId=${branchId}&type=${type}&eventDate=${eventDate}`, token);
};
// 更新今日備注
const updateTodayNote = (token, branchId, type, eventDate, note) => {
  return request("put", `${router}/notes`, token, {
    branchId,
    type,
    eventDate,
    note,
  });
};

const createConsultingRoom = (token, data) => {
  return request("post", `${router}/createConsultingRooms`, token, data);
};

const getConsultingRooms = (token, branchId) => {
  return request("get", `${router}/getConsultingRooms?branchId=${branchId}`, token);
};

const updateConsultingRoomStatus = (token, data) => {
  return request("put", `${router}/updateConsultingRoomStatus`, token, data);
};

const updateConsultingRoomEquipments = (token, data) => {
  return request("put", `${router}/updateConsultingRoomEquipments`, token, data);
};

const createConsultingRoomEquipments = (token, data) => {
  return request("post", `${router}/createConsultingRoomEquipments`, token, data);
};

const deleteConsultingRoomEquipments = (token, id) => {
  return request("delete", `${router}/deleteConsultingRoomEquipments?id=${id}`, token);
};

const moveConsultingRoomEquipments = (token, data) => {
  return request("put", `${router}/moveConsultingRoomEquipments`, token, data);
};

const deleteConsultingRoom = (token, id) => {
  return request("delete", `${router}/deleteConsultingRoom?id=${id}`, token);
};




export {
  createBalance,
  createPackage,
  getPackage,
  buyPackage,
  getMemberCheckoutPackage,
  getMemberTicketByMemberId,
  editPackageStatus,
  delBrandProductsById,
  editPackage,
  consumablesRecord,
  consumableItem,
  updateAppointmentVerifications,
  adjustBrandMemberPoints,
  adjustBrandMemberBalance,
  getBrandMemberPoints,
  getBrandMemberBalance,
  sendCoupon,
  getSendCoupon,
  updateReferralBranch,
  checkAnyIntroducerPhone,
  checkAnyIntroducerOrigin,
  brandMemberBalanceLog,
  // brandTicketLog,
  switchBranch,
  adjustUserPoints,
  getReferralRecords,
  createConsultingRoom,
  getConsultingRooms,
  updateConsultingRoomStatus,
  updateConsultingRoomEquipments,
  createConsultingRoomEquipments,
  deleteConsultingRoomEquipments,
  moveConsultingRoomEquipments,
  deleteConsultingRoom,

  getTodayNote,
  updateTodayNote
};
